import { memo } from "react";
import bgTop from "../Assets/Images/bg-top-blue.svg";
import bgBottom from "../Assets/Images/bg-bottom.png";

const SKELETON_CARD_COUNT = 4;

const FilterSkeleton = () => (
  <div className="col-12 col-md-4 mb-2">
    <span
      className="placeholder d-block mb-2"
      style={{ width: 60, height: 14, borderRadius: 4 }}
      aria-hidden="true"
    />
    <span
      className="placeholder d-block w-100"
      style={{ height: 45, borderRadius: 5 }}
      aria-hidden="true"
    />
  </div>
);

const CardSkeleton = () => (
  <div className="card shadow border-0 br-10px mb-5">
    <div className="row g-0">
      <div className="col-sm-3">
        <span
          className="placeholder d-block w-100 h-100"
          style={{ minHeight: 150, borderRadius: 10 }}
          aria-hidden="true"
        />
      </div>
      <div className="col-sm-8">
        <div className="card-body p-4">
          <span
            className="placeholder d-block col-5 mb-3"
            style={{ height: 18, borderRadius: 4 }}
            aria-hidden="true"
          />
          <span
            className="placeholder d-block col-12 mb-2"
            style={{ height: 12, borderRadius: 4 }}
            aria-hidden="true"
          />
          <span
            className="placeholder d-block col-10 mb-2"
            style={{ height: 12, borderRadius: 4 }}
            aria-hidden="true"
          />
          <span
            className="placeholder d-block col-7"
            style={{ height: 12, borderRadius: 4 }}
            aria-hidden="true"
          />
        </div>
      </div>
    </div>
  </div>
);

/**
 * Loading skeleton for the Tips & Tricks screen — mirrors the real layout
 * (banner, heading, the two filter dropdowns and the card list) so there is no
 * layout shift once data arrives. Uses Bootstrap's `placeholder` utilities.
 */
const TipsTricksSkeleton = () => (
  <div
    className="position-relative placeholder-glow"
    role="status"
    aria-label="Loading"
  >
    <img className="bg-top d-none d-lg-block" src={bgTop} alt="" />
    <div className="container-xxl my-4">
      <p className="fw-bold mt-5 font-21">Checkout Useful Tips!</p>

      <div className="row mb-5">
        <FilterSkeleton />
        <FilterSkeleton />
      </div>

      {Array.from({ length: SKELETON_CARD_COUNT }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <CardSkeleton key={index} />
      ))}
    </div>
    <img className="bg-bottom" src={bgBottom} alt="" />
    <span className="visually-hidden">Loading…</span>
  </div>
);

export default memo(TipsTricksSkeleton);
